"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      passportDetails: _propTypes.default.string,
      passportNumber: _propTypes.default.string,
      expiryDate: _propTypes.default.string,
      expiredError: _propTypes.default.string,
      requiredError: _propTypes.default.string,
      maxLengthError: _propTypes.default.string,
      type: _propTypes.default.string,
      nationalId: _propTypes.default.string,
      docNumber: _propTypes.default.string,
      passport: _propTypes.default.string
    }),
    formRef: _propTypes.default.object,
    onSubmit: _propTypes.default.func,
    initialValues: _propTypes.default.shape({
      givenName: _propTypes.default.string,
      familyName: _propTypes.default.string,
      nationality: _propTypes.default.string,
      gender: _propTypes.default.string,
      dateOfBirth: _propTypes.default.string,
      docNumber: _propTypes.default.string,
      type: _propTypes.default.string
    }),
    hasOtherElement: _propTypes.default.bool,
    isWMP: _propTypes.default.bool,
    isPassportMandatory: _propTypes.default.bool,
    isExpiryDateMandatory: _propTypes.default.bool,
    isDropdown: _propTypes.default.bool,
    documentTypes: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.string
    })),
    disableDocumentNumber: _propTypes.default.bool,
    disableExpiryDate: _propTypes.default.bool,
    disableDropdown: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    onSubmit: function onSubmit() {},
    handleField: function handleField() {},
    initialValues: _constant2.INITIAL_VALUES,
    hasOtherElement: false,
    isWMP: false,
    isPassportMandatory: false,
    isExpiryDateMandatory: false,
    isDropdown: false,
    disableDocumentNumber: false,
    disableExpiryDate: false,
    disableDropdown: false
  }
};
exports.default = _default;